<template>
  <div class="not-found-error">
    <p><span>😑 </span>页面找不到</p>
    <br><br>
    <el-button @click="historyBack">返回</el-button>
  </div>
</template>

<script>

export default {
  methods: {
    historyBack() {
      this.$router.go(-1);
      // window.history.back(-1);
    },
  },

  created() {
  },
};
</script>

<style lang="scss" scoped>
  .not-found-error {
    padding: 30px;
    p {
      color: #666;
      span {
        font-size: 24px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/not-found-error.vue